module.exports = __webpack_public_path__ + "static/media/gr.368bc9df.svg";